import { Container } from "react-bootstrap";
import PageTitle from '../common/PageTitleBanner';

const Gallery = () => {
    return (
        <>
            <PageTitle subtitle="Gallery" title="Our Portfolio" bannerImage="assets/images/banner.jpg" />
            <section className="content-section">
                <Container>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="gallery-block">
                                <div className="gallery-image embed-responsive embed-responsive-16by9">
                                    <img src="assets/images/projects/project-1.jpg" className="embed-responsive-item" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="gallery-block">
                                <div className="gallery-image embed-responsive embed-responsive-16by9">
                                    <img src="assets/images/projects/project-2.jpg" className="embed-responsive-item" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="gallery-block">
                                <div className="gallery-image embed-responsive embed-responsive-16by9">
                                    <img src="https://picsum.photos/200/300" className="embed-responsive-item" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="gallery-block">
                                <div className="gallery-image embed-responsive embed-responsive-16by9">
                                    <img src="https://picsum.photos/300/300" className="embed-responsive-item" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="gallery-block">
                                <div className="gallery-image embed-responsive embed-responsive-16by9">
                                    <img src="https://picsum.photos/400/300" className="embed-responsive-item" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="gallery-block">
                                <div className="gallery-image embed-responsive embed-responsive-16by9">
                                    <img src="https://picsum.photos/200/400" className="embed-responsive-item" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="gallery-block">
                                <div className="gallery-image embed-responsive embed-responsive-16by9">
                                    <img src="https://picsum.photos/300/600" className="embed-responsive-item" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="gallery-block">
                                <div className="gallery-image embed-responsive embed-responsive-16by9">
                                    <img src="https://picsum.photos/400/800" className="embed-responsive-item" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="gallery-block">
                                <div className="gallery-image embed-responsive embed-responsive-16by9">
                                    <img src="https://picsum.photos/700/300" className="embed-responsive-item" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="gallery-block">
                                <div className="gallery-image embed-responsive embed-responsive-16by9">
                                    <img src="https://picsum.photos/500/400" className="embed-responsive-item" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="gallery-block">
                                <div className="gallery-image embed-responsive embed-responsive-16by9">
                                    <img src="https://picsum.photos/600/600" className="embed-responsive-item" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="gallery-block">
                                <div className="gallery-image embed-responsive embed-responsive-16by9">
                                    <img src="https://picsum.photos/800/800" className="embed-responsive-item" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </>
    )
}
export default Gallery;